module.exports = __webpack_public_path__ + "img/用车明细表示例1.2a757773.png";